import { KoncentroBaseModel } from './koncentro-base.model';
import { Acm } from './loyalty-acm.model';

export class Channel extends KoncentroBaseModel{
  dto ?= 'ChannelDto';

  id?: string;
  channel_code: string;
  description: string;
  default_store_id?: string;
  storeDescription?: string;
  channelDescription?: string;
  default_acm_id?: number;
}



// WEBPACK FOOTER //
// ./src/app/models/loyalty-channel.model.ts